import lockLookupTable from 'Helper/lockLookupTable'

export function acquireLock(windowRef, patientId = null) {
  const lockname = lockLookupTable(windowRef)
  if (lockname) {
    return {
      type: 'ACQUIRE_LOCK',
      lockname,
      patientId
    }
  } else {
    return { type: 'NO_ACTION' }
  }
}

export function releaseLock(windowRef) {
  const lockname = lockLookupTable(windowRef)
  if (lockname) {
    return {
      type: 'RELEASE_LOCK',
      lockname
    }
  } else {
    return { type: 'NO_ACTION' }
  }
}
